module.exports = __webpack_public_path__ + "img/首页头图.eeabe5d1.png";